import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/advanceSummaryCard.module.scss';
import { formatScaleAmount } from '../../../../../utils/numbers';

/**
 * Presentational. Receives a pre-cooked bundle from
 * `VolumeTiersPanelController.getChart()`:
 *  - `segments`: validated, sorted, each with `widthRatio` (0..1)
 *  - `maxAmount`: numeric upper bound of the last segment
 */
function FeeByVolumeChart({ segments = [], maxAmount = 0 }) {
    if (!segments.length) return null;

    return (
        <section className={styles.chartSection}>
            <div className={styles.chartCard}>
                <Text as="span" size="xs" className={styles.chartTitle}>
                    Fee Summary by Volume
                </Text>
                <div className={styles.chartValues}>
                    {segments.map((seg) => (
                        <div
                            key={seg.id}
                            className={styles.chartValueCell}
                            style={{ width: `${seg.widthRatio * 100}%` }}
                        >
                            <Text as="span" size="xs" className={styles.chartValuePill}>
                                ${(Number(seg.fee) || 0).toFixed(2)}
                            </Text>
                        </div>
                    ))}
                </div>
                <div className={styles.chartBar} role="presentation" />
                <div className={styles.chartScale}>
                    {segments.map((seg) => (
                        <Text key={seg.id} as="span" size="xs" className={styles.chartScaleItem}>
                            {formatScaleAmount(seg.from)}
                        </Text>
                    ))}
                    <Text as="span" size="xs" className={styles.chartScaleItem}>
                        {formatScaleAmount(maxAmount)}
                    </Text>
                </div>
            </div>
        </section>
    );
}

export default FeeByVolumeChart;
